import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { RootState } from "../store";

const synergyApiEndpoints = ["getEdits", "getEditClips"];

export interface PlayQueryParams {
  sortOrderValue?: string;
  sortFieldValue?: string;
}

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    prepareHeaders: (headers, api) => {
      const state = api.getState() as RootState;
      // based on api type, select either token or synergyToken
      const endpoint = api.endpoint;
      const { token, synergyToken } = state.auth;
      const authToken = synergyApiEndpoints.includes(endpoint) ? synergyToken : token;
      // Check if headers already has Authorization header.
      if (!headers.has("Authorization")) {
        headers.append("Authorization", `Bearer ${authToken}`);
      }
    },
  }),
  tagTypes: ["PlayData", "Team", "Series", "Tag", "UserPlaySettings", "Playbook", "PrintStyle"],
  endpoints: () => ({}),
});
